<template>
  <div class="pages" v-if="page_count != 0">
    <paginate
      ref="paginate"
      :page-count="page_count"
      :click-handler="pageChange"
      :prev-link-class="'prevBtn'"
      :next-link-class="'nextBtn'"
      :prev-text="''"
      :next-text="''"
      :no-li-surround="true"
      :force-page="index"
      :container-class="'paginate'">
    </paginate>
    <p class="counts">{{`共${total}条`}}</p>
    <p class="counts noPdLeft">{{`共${page_count}页`}}</p>
    <div class="skip" v-if="page_count > 1">
      <p>跳至</p>
      <input type="number" v-model="jumper" @keyup.enter="changePage">
      <p>页</p>
    </div>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import common from "@common/common";

export default {
  name: "pages",
  components: { Paginate },
  props: {
    page_count: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      jumper: ""
    };
  },

  methods: {
    pageChange(d) {
      console.log(d)
      common.goTop();
      this.$parent.page.pageIndex = d;
      this.$parent.getList()
    },
    changePage() {
      let page = this.jumper - 0;
      if (page > this.page_count) {
        page = this.page_count;
        this.jumper = this.page_count;
      }

      if (page === 0) {
        page = 1;
        this.jumper = 1;
      }

      common.goTop();
      this.$refs.paginate.handlePageSelected(page);
      this.jumper = "";
    }
  },
  watch: {
    items: function(n) {
      console.log(33, n);
    },
    index: function(n) {
      console.log("force", n);
      this.$refs.paginate.selected = n;
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/global.less";

.pages {
  display: flex;
  justify-content: flex-end;
  padding: 0 30px;
  margin: 30px 0 0;
  align-items: center;
  .counts {
    line-height: 30px;
    padding: 0 20px;
    height: 30px;
    font-size: 14px;
    color: @dark;
  }
  .noPdLeft {
    padding-left: 0;
  }
  .skip {
    display: flex;
    font-size: 14px;
    color: @dark;
    align-items: center;
    input {
      background-color: transparent;
      width: 50px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #dcdcdc;
      border-radius: 4px;
      margin: 0 8px;
    }
  }
}
</style>
